import {TreeViewBaseItem} from '@mui/x-tree-view';
import {ModuleTopic} from '@cp/model';
import mapModuleTopicToTopicId from './mapModuleTopicToTopicId';

export type TopicTreeObject = TreeViewBaseItem<{
  id: string;
  label: string;
}>;

/**
 * Map topics to a tree object
 * @param topics - The topics to map to a tree object
 * @returns Tree object with Category > Topic structure (2 levels)
 */
export default function mapTopicsToTreeObject(topicsObject: Record<string, ModuleTopic[]>): TopicTreeObject[] {
  return Object.entries(topicsObject).map(([category, moduleTopics]) => ({
    id: category,
    label: category,
    children: moduleTopics.map((moduleTopic) => ({
      id: mapModuleTopicToTopicId(moduleTopic),
      label: moduleTopic.topic,
    })),
  }));
}
